import {useMutation} from '@tanstack/react-query';

import {useOntologyDocsQueryCache} from '../use-ontology-docs-query';

import {useCategoriesInfiniteQueryCache} from './use-categories-infinite-query-cache';

interface AddDocumentToCategoryPayload {
    categoryId: string;
    document: EditModeDoc;
}

/** Add document to categories of BTB documents */
export function useAddDocumentToCategoryCache() {
    const ontologyDocsQueryCache = useOntologyDocsQueryCache();
    const categoriesInfiniteQueryCache = useCategoriesInfiniteQueryCache();

    return useMutation<unknown, Error, AddDocumentToCategoryPayload>({
        mutationFn: async (payload) => {
            categoriesInfiniteQueryCache.updateDocumentsCount(payload.categoryId, 1);
            ontologyDocsQueryCache.addDocument(payload.document, payload.categoryId);

            // We must invalidate the cache to update the root category counter
            await categoriesInfiniteQueryCache.invalidate();
            await ontologyDocsQueryCache.invalidate(payload.document.type);
        }
    });
}
